// extracted by mini-css-extract-plugin
module.exports = {"sticky":"THead_sticky__RNeps"};